<script setup>
import { defineProps, defineEmits } from 'vue'

defineProps({
  title: {
    type: String,
    default: 'Show Charges'
  }
})

const emit = defineEmits(['click'])

const clickButton = (event) => {
  emit('click', event)
}
</script>

<template>
  <v-tooltip top color="warning">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        small
        :icon="true"
        class="price-history-btn"
        @click="clickButton"
      >
        <font-awesome-icon :icon="['fas', 'file-invoice-dollar']" />
      </v-btn>
    </template>

    <span>{{ title }}</span>
  </v-tooltip>
</template>

<style scoped>
.price-history-btn {
  color: #6c757d !important;
}

.price-history-btn:hover {
  color: #f7d514 !important;
}
</style>
